<div class="campaign-header">
  <div class="header-content">
    <div class="text-content">
      <h1 class="title">Campaigns</h1>
      <p class="subtitle">Manage your marketing campaigns.</p>
    </div>
  </div>
  
  <button class="btn btn-primary btn-medium" (click)="onCreateCampaign()">
    <svg class="plus-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 4.17V15.83M4.17 10H15.83" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>Create Campaign</span>
  </button>
</div>